export default {
  pt: {
    ops: "Ops...",
    mainMessage: "Acesse pelo seu smartphone!",
    subMessage: "Esta aplicação foi projetada apenas para dispositivos móveis.",
  },

  en: {
    ops: "Oops...",
    mainMessage: "Access it from your smartphone!",
    subMessage: "This application was designed for mobile devices only.",
  },
};
